import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './meta-feature-list_types.2';

export function getMetaFeatureList(variable: types.GetMetaFeatureListVariables, options?: GqlRequestOptions) {
  const query = 'query GetMetaFeatureList($ui: String, $platfrom: String!, $data_version: Int!) { metadata(ui: $ui, platform: $platfrom, data_version: $data_version) { feature_list } }';
  return gql_request<types.GetMetaFeatureList, types.GetMetaFeatureListVariables>('GetMetaFeatureList', query, variable, { use_consumer: true, ...options });
}

